import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {UserErrorsFactory} from '../Errors/factory.js'
import UserRepositoriesFactory from '../Repositories/factory.js'
import UserServicesFactory from '../Services/factory.js'

class GetMessagingProviderTokenUserUseCase extends UseCase {
  #config
  #repository
  #currentUserService
  #userNotLoggedInUserError

  constructor({config, repository, currentUserService, userNotLoggedInUserError}) {
    super()
    this.#config = config
    this.#repository = repository
    this.#currentUserService = currentUserService
    this.#userNotLoggedInUserError = userNotLoggedInUserError
  }

  static create({config}) {
    return new GetMessagingProviderTokenUserUseCase({
      config,
      repository: UserRepositoriesFactory.httpUserRepository({config}),
      currentUserService: UserServicesFactory.getCurrentUserService({config}),
      userNotLoggedInUserError: UserErrorsFactory.userNotLoggedInUserError
    })
  }

  @tracer({metric: 'GetMessagingProviderTokenUserUseCase#execute'})
  @AsyncInlineError()
  async execute() {
    const userEntity = await this.#currentUserService.execute()

    if (!userEntity)
      return Promise.reject(
        this.#userNotLoggedInUserError({
          message: 'To get the token of the messaging provider the user must be logged in'
        }).toJSON()
      )

    const [error, response] = await this.#repository.getMessagingProviderTokenUserUseCase({
      userEntity
    })
    return error ? Promise.reject(error) : response.toJSON()
  }
}

export const factory = GetMessagingProviderTokenUserUseCase.create
